import React, { useEffect, useState } from "react";
import { Header } from "../components/ui/header";
import { money } from "../utilities/currency";
import { Footer } from "../components/ui/footer";
import axios from "axios";

type personVernPageProps = {
    currentUser: any,
    onLogout: any,
    baseUrl: string,
    onLoginClick: any,
    onLoginSuccess: any,
}
const T = {
    offer: "✨ Spesialtilbud – Betal 99 kr, få 198 kr i ringe kreditt! ✨",
    signIn: "Logg inn",
    join: "Bli med",
    allAdvisors: "Alle veiledere",
    festivalTitle: "Festivalkampanjer",
    referTitle: "Verv & få gratis reading!",
    referBody: "Verv 5 betalende kunder og få en GRATIS 15‑min reading hos en toppveileder.",
    blogTitle: "Fra Mystic‑bloggen",
    viewAll: "Se alle",
    subscribeLine: "Få nye guider og tilbud på e‑post.",
    read: "Les",
    invite: "Inviter venner",
    sponsored: "Sponset",
    ad: (n: number) => `Annonse ${n}`,
    adBlurb: "Annonser produkter, apper eller arrangementer her.",
    learnMore: "Les mer",
    connectNow: "Koble til nå",
    from: "fra",
    minutes: "min",
    verified: "Verifisert",
    categories: [
        "Kjærlighetsreading",
        "Klarsynt reading",
        "Tarot‑reading",
        "Astrologi & Horoskop",
        "Englebudskap",
        "Orakel‑veiledning",
        "Drømmetydning",
        "Åndelig medium",
    ],
    hero: {
        name: "Klarsynte Eirik",
        tag: "Kjærlighetsekspert",
        blurb:
            "Mitt løfte: Jeg er her for deg. Når det er vanskelig å vite hvem man kan stole på, er ekte nærvær alt.",
        getReading: "Bestill reading",
    },
    footer: {
        getApp: "Få appen for klarhet hvor du enn er.",
        explore: "Utforsk",
        special: "Spesialiteter",
        more: "Mer",
        advisors: "Veiledere",
        blog: "Bloggen vår",
        applyCode: "Bruk kampanjekode",
        support: "Kundesupport",
        about: "Om oss",
        apply: "Veileder? Søk her",
        privacy: "Personvern",
        terms: "Vilkår",
    },
    wallet: {
        title: "Kjøp ringeminutter",
        intro:
            "Minutter lagres i din Mystic‑wallet og kan brukes hos alle veiledere (chat / samtale / video).",
        numLabel: "Telefonnummeret du ringer fra",
        amount: "Velg beløp",
        buy: (amt: number) => `Kjøp ${money(amt)} kreditt`,
        learn: "Les mer om betalingsmåter",
        err: "Skriv inn et gyldig telefonnummer",
        otp: (n: string) => `Kode sendt til ${n}. Skriv den inn for å bekrefte.`,
        enterOtp: "Skriv inn kode",
        verify: "Bekreft & legg til kreditt",
        cancel: "Avbryt",
        success: (amt: number) => `${money(amt)} lagt til i lommeboken!`,
        pm1: "Vipps MobilePay",
        pm2: "Kort (krever registrering på ditt mobilnummer)",
        nolgin: "Ingen innlogging nødvendig for Vipps MobilePay – ring direkte.",
    },
};
export default function PersonvernPage({ currentUser, onLogout, baseUrl, onLoginClick, onLoginSuccess }: personVernPageProps) {
    const [wallet, setWallet] = useState(0);
    const [scrolled, setScrolled] = useState(false);

    useEffect(() => {
        if (currentUser?.role === "customer") {
            axios.get(baseUrl + "/getCustomerWallet", { params: { token: currentUser.token } })

                .then((response) => {
                    if (response.data.status === "OK") {
                        setWallet(response.data.data.remaining_amount);
                    }
                });
        }
    }, [currentUser, baseUrl])

    return (
        <div className={"bg-white text-gray-900"}>
            <Header wallet={wallet} scrolled={scrolled} T={T} onLoginClick={onLoginClick} currentUser={currentUser} onLogout={onLogout} baseUrl={baseUrl}/>
            <main className="min-h-screen bg-gray-50 text-gray-800 py-16 px-6 md:px-12 lg:px-24">
                <div className="max-w-4xl mx-auto bg-white shadow-md rounded-2xl p-10">
                    <h1 className="text-3xl md:text-4xl font-extrabold text-gray-900 mb-6 text-center">
                        Personvernerklæring og GDPR
                    </h1>
                    <p className="text-gray-600 text-center mb-10">
                        Sist oppdatert: 11. november 2025
                    </p>

                    <section className="space-y-6 leading-relaxed">
                        <p>
                            Denne personvernerklæringen forklarer hvordan vi samler inn, bruker, beskytter og deler personopplysninger i tråd med EUs
                            personvernforordning (GDPR). Vi behandler alle personopplysninger med respekt, sikkerhet og konfidensialitet.
                        </p>

                        <h2 className="text-2xl font-bold text-gray-900 mt-10">1. Behandlingsansvarlig</h2>
                        <p>
                            Chamcore Technologies er behandlingsansvarlig for alle personopplysninger som samles inn via våre tjenester og digitale plattformer.
                            Kontakt oss på <a href="mailto:privacy@chamcore.com" className="text-blue-600 underline">privacy@chamcore.com</a> dersom du har spørsmål om personvern.
                        </p>

                        <h2 className="text-2xl font-bold text-gray-900 mt-10">2. Hvilke opplysninger vi samler inn</h2>
                        <ul className="list-disc pl-6 space-y-2">
                            <li>Navn, adresse, telefonnummer, e-postadresse og alder</li>
                            <li>IP-adresse, enhetsinformasjon og nettleserdata</li>
                            <li>Bruksdata fra våre nettsider og applikasjoner</li>
                            <li>De fire siste sifrene av ditt betalingskort (for identifikasjon av registrerte betalingsmetoder). All annen betalingsinformasjon lagres kun hos vår betalingsleverandør, ikke hos oss</li>
                        </ul>

                        <h2 className="text-2xl font-bold text-gray-900 mt-10">3. Innsyn og kontroll</h2>
                        <p>
                            Du kan til enhver tid se hvilke personopplysninger vi har lagret om deg ved å gå til din profil. Dette inkluderer ikke informasjon
                            som er rapporteringspliktig for regnskap, fakturering eller årsoppgjør. Du kan også oppdatere eller be om sletting av data som ikke
                            er juridisk pålagt å lagres. Vi henter din informasjon automatisk gjennom våre API-løsninger mot betalingsleverandørene som er registrert eller i bruk av deg, og synkroniserer denne informasjonen automatisk for å sikre at dine data alltid er oppdatert. Du kan selv manuelt synkronisere denne informasjonen mot dine betalingsmetoder (Stripe eller Vipps) for å sikre at endringer oppdateres umiddelbart.
                        </p>

                        <h2 className="text-2xl font-bold text-gray-900 mt-10">4. Formål med behandlingen</h2>
                        <p>
                            Vi behandler personopplysninger for å levere våre tjenester, forbedre brukeropplevelsen, administrere kundekontakt og oppfylle
                            juridiske krav. Informasjon brukes kun til formål som er nødvendige for drift og sikkerhet.
                        </p>

                        <h2 className="text-2xl font-bold text-gray-900 mt-10">5. Dine rettigheter</h2>
                        <p>
                            Du har rett til innsyn i hvilke opplysninger vi har lagret om deg, og kan be om retting, sletting eller begrensning av behandlingen.
                            Du har også rett til dataportabilitet og til å trekke tilbake eventuelle samtykker.
                        </p>

                        <h2 className="text-2xl font-bold text-gray-900 mt-10">6. Lagring og sikkerhet</h2>
                        <p>
                            Personopplysninger lagres kun så lenge det er nødvendig for formålet. Vi benytter moderne sikkerhetsløsninger som kryptering,
                            tofaktorautentisering og tilgangskontroll for å beskytte dine data.
                        </p>

                        <h2 className="text-2xl font-bold text-gray-900 mt-10">7. Deling av opplysninger</h2>
                        <p>
                            Vi deler ikke personopplysninger med tredjeparter, med mindre dette er nødvendig for å oppfylle juridiske forpliktelser eller
                            levere tjenestene du har bedt om (f.eks. betalingsformidlere eller offentlige myndigheter).
                        </p>

                        <h2 className="text-2xl font-bold text-gray-900 mt-10">8. Informasjonskapsler (Cookies)</h2>
                        <p>
                            Våre nettsteder bruker informasjonskapsler for å gi bedre funksjonalitet og analyse. Du kan administrere eller deaktivere cookies
                            i nettleseren din når som helst.
                        </p>

                        <h2 className="text-2xl font-bold text-gray-900 mt-10">9. Endringer i erklæringen</h2>
                        <p>
                            Vi kan oppdatere denne erklæringen ved behov for å reflektere endringer i lover, teknologi eller våre tjenester. Oppdatert versjon
                            vil alltid være tilgjengelig på våre nettsider.
                        </p>

                        <div className="mt-12 border-t pt-6 text-center text-sm text-gray-600">
                            <p>© {new Date().getFullYear()} Chamcore Technologies. Alle rettigheter forbeholdt.</p>
                        </div>
                    </section>
                </div>
            </main>
            <Footer baseUrl={baseUrl} />
        </div>
    );
}
